import { render } from "./termsPage.vue?vue&type=template&id=2247733e&scoped=true"
import script from "./termsPage.vue?vue&type=script&lang=js"
export * from "./termsPage.vue?vue&type=script&lang=js"

import "./termsPage.vue?vue&type=style&index=0&id=2247733e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2247733e"]])

export default __exports__